import { Component, OnInit, ElementRef } from '@angular/core';
import { TherapistScaleResultsComponent } from 'app/reports/report-items/therapist-scale-results/therapist-scale-results.component';
import { ReportNavigatorService } from 'app/reports/services/report-navigator.service';
import { ScaleResult } from 'app/shared/models/scale-result';

@Component({
  selector: 'dac-client-scale-results',
  templateUrl: './client-scale-results.component.html',
  styleUrls: ['./client-scale-results.component.scss']
})
export class ClientScaleResultsComponent extends TherapistScaleResultsComponent implements OnInit {

  constructor(navigator:ReportNavigatorService, el:ElementRef) { 
    super(navigator, el)
  }

  ngOnInit() {
    super.ngOnInit();
  }

  ngAfterViewInit() {
    super.ngAfterViewInit();
  }
  ngOnDestroy() {
    super.ngOnDestroy();
  }

  hasContent(scaleResult:ScaleResult) {
    if (scaleResult && scaleResult.range)
    {
      return scaleResult.range.clientContent || scaleResult.range.therapistContent;
    }
    return false;
  }

  getContent(scaleResult:ScaleResult) {
    if (scaleResult && scaleResult.range)
    {
      if (scaleResult.range.clientContent) {
        return scaleResult.range.clientContent;
      }
      else {
        return scaleResult.range.therapistContent;
      }
    }
    return "";
  }

}



// WEBPACK FOOTER //
// ./src/app/reports/report-items/client-scale-results/client-scale-results.component.ts